<template>
<div class="topbarmobile">
    <div class="leftside">
        <div 
            class="close_menu" 
            @click="rollMenu">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5 6.38988V2.98488C16.5 1.92738 16.02 1.49988 14.8275 1.49988H11.7975C10.605 1.49988 10.125 1.92738 10.125 2.98488V6.38238C10.125 7.44738 10.605 7.86738 11.7975 7.86738H14.8275C16.02 7.87488 16.5 7.44738 16.5 6.38988Z" fill="white"/>
                <path d="M16.5 14.8275V11.7975C16.5 10.605 16.02 10.125 14.8275 10.125H11.7975C10.605 10.125 10.125 10.605 10.125 11.7975V14.8275C10.125 16.02 10.605 16.5 11.7975 16.5H14.8275C16.02 16.5 16.5 16.02 16.5 14.8275Z" fill="white"/>
                <path d="M7.87494 6.38988V2.98488C7.87494 1.92738 7.39494 1.49988 6.20244 1.49988H3.17244C1.97994 1.49988 1.49994 1.92738 1.49994 2.98488V6.38238C1.49994 7.44738 1.97994 7.86738 3.17244 7.86738H6.20244C7.39494 7.87488 7.87494 7.44738 7.87494 6.38988Z" fill="white"/>
                <path d="M7.87494 14.8275V11.7975C7.87494 10.605 7.39494 10.125 6.20244 10.125H3.17244C1.97994 10.125 1.49994 10.605 1.49994 11.7975V14.8275C1.49994 16.02 1.97994 16.5 3.17244 16.5H6.20244C7.39494 16.5 7.87494 16.02 7.87494 14.8275Z" fill="white"/>
            </svg>
        </div>
    </div>
    <div class="rightside">
        <div class="left">
        </div>
        <div class="right">
            <div class="picture" @click="profil">
                <!-- <span v-if="isSubscriptionPaid">
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.776963 1.4404L2.31806 2.75847L3.69107 1.11522C3.72952 1.06928 3.77813 1.03236 3.83329 1.00722C3.88845 0.982075 3.94874 0.969351 4.00966 0.969994C4.07058 0.970637 4.13057 0.984632 4.18515 1.01093C4.23974 1.03724 4.28752 1.07517 4.32493 1.12191L5.63516 2.75807L7.22608 1.42111C7.28855 1.36872 7.366 1.33612 7.44806 1.32768C7.53012 1.31925 7.61287 1.33538 7.68524 1.37391C7.75761 1.41244 7.81614 1.47154 7.85301 1.5433C7.88987 1.61506 7.90331 1.69605 7.89152 1.77543L7.284 5.84891H0.725526L0.108683 1.79394C0.0964297 1.71411 0.109713 1.63255 0.146734 1.56031C0.183755 1.48807 0.242725 1.42863 0.315655 1.39005C0.388586 1.35147 0.471954 1.3356 0.554468 1.34461C0.636982 1.35362 0.714653 1.38706 0.776963 1.4404ZM0.757118 6.2426H7.23742V6.63628C7.23742 6.7407 7.19475 6.84083 7.11879 6.91466C7.04284 6.98849 6.93982 7.02997 6.8324 7.02997H1.16214C1.05472 7.02997 0.951701 6.98849 0.875745 6.91466C0.799789 6.84083 0.757118 6.7407 0.757118 6.63628V6.2426Z" fill="#FEF3C7"/>
                    </svg>
                </span> -->
                {{picture()}}
            </div>
            <div class="settings" @click="profil">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.04297 1.21899C6.77697 0.126994 5.22297 0.126994 4.95697 1.21899C4.91726 1.38308 4.83936 1.53548 4.72963 1.66378C4.61989 1.79208 4.48141 1.89266 4.32546 1.95733C4.16951 2.02201 4.0005 2.04894 3.83217 2.03596C3.66384 2.02297 3.50096 1.97042 3.35677 1.88259C2.39637 1.29739 1.29737 2.39639 1.88257 3.35679C2.26057 3.97699 1.92527 4.78619 1.21967 4.95769C0.126972 5.22299 0.126972 6.77769 1.21967 7.04229C1.38381 7.08206 1.53623 7.16002 1.66453 7.26984C1.79283 7.37966 1.89338 7.51823 1.95799 7.67427C2.0226 7.8303 2.04945 7.99939 2.03634 8.16776C2.02323 8.33614 1.97055 8.49904 1.88257 8.64319C1.29737 9.60359 2.39637 10.7026 3.35677 10.1174C3.50093 10.0294 3.66383 9.97673 3.8322 9.96362C4.00057 9.95052 4.16966 9.97737 4.3257 10.042C4.48173 10.1066 4.6203 10.2071 4.73012 10.3354C4.83994 10.4637 4.91791 10.6162 4.95767 10.7803C5.22297 11.873 6.77767 11.873 7.04227 10.7803C7.08217 10.6162 7.16021 10.4639 7.27006 10.3357C7.3799 10.2075 7.51845 10.107 7.67443 10.0424C7.83042 9.97783 7.99944 9.95096 8.16777 9.96399C8.3361 9.97701 8.49898 10.0296 8.64317 10.1174C9.60357 10.7026 10.7026 9.60359 10.1174 8.64319C10.0296 8.499 9.97699 8.33612 9.96396 8.1678C9.95094 7.99947 9.97781 7.83044 10.0424 7.67445C10.107 7.51847 10.2075 7.37992 10.3357 7.27008C10.4639 7.16023 10.6162 7.08219 10.7803 7.04229C11.873 6.77699 11.873 5.22229 10.7803 4.95769C10.6161 4.91793 10.4637 4.83996 10.3354 4.73014C10.2071 4.62032 10.1066 4.48175 10.042 4.32572C9.97734 4.16968 9.9505 4.0006 9.9636 3.83222C9.97671 3.66385 10.0294 3.50095 10.1174 3.35679C10.7026 2.39639 9.60357 1.29739 8.64317 1.88259C8.49901 1.97057 8.33612 2.02326 8.16774 2.03636C7.99937 2.04947 7.83028 2.02262 7.67425 1.95801C7.51821 1.8934 7.37964 1.79285 7.26982 1.66455C7.16 1.53625 7.08204 1.38383 7.04227 1.21969L7.04297 1.21899ZM5.99997 8.09999C6.55693 8.09999 7.09107 7.87874 7.4849 7.48492C7.87872 7.09109 8.09997 6.55695 8.09997 5.99999C8.09997 5.44304 7.87872 4.9089 7.4849 4.51507C7.09107 4.12124 6.55693 3.89999 5.99997 3.89999C5.44302 3.89999 4.90887 4.12124 4.51505 4.51507C4.12122 4.9089 3.89997 5.44304 3.89997 5.99999C3.89997 6.55695 4.12122 7.09109 4.51505 7.48492C4.90887 7.87874 5.44302 8.09999 5.99997 8.09999Z" fill="#263544"/>
                </svg>
            </div>
            <div class="logout" @click="logout">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.1733 8.52832L11.6667 7.03499L10.1733 5.54166" stroke="#212541" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.69336 7.03497H11.6259" stroke="#212541" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.86003 11.6667C4.28169 11.6667 2.19336 9.91668 2.19336 7.00001C2.19336 4.08334 4.28169 2.33334 6.86003 2.33334" stroke="#212541" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props:['data', 'nice_paid_type'],
    computed: {
        isSubscriptionPaid() {
            if (this.nice_paid_type == 'Zdarma') {
                return false;
            }
            return true;
        }
    },
    methods: {
        rollMenu(){
            $('.menuleftmobile').removeClass('hide')
            $('.pcoded-content').removeClass('hide')
        },
        picture(){
            if (this.data.auth.meno != null && this.data.auth.priezvisko != null) {
                var one = this.data.auth.meno.charAt(0).toUpperCase();
                var two = this.data.auth.priezvisko.charAt(0).toUpperCase();
                return one + two;
            } else if (this.data.auth.meno != null) {
                return this.data.auth.meno.charAt(0).toUpperCase();
            } else {
                return '';
            }
        },
        premium(){
            //window.location.href = '/admin/balicky';
        },
        profil(){
            window.location.href = '/admin/nastavenia/ucet';
        },
        logout() {
            $('#logout-form').submit();
        }
    },
    
}
</script>

<style lang="scss" scoped>
.topbarmobile{
    display: none;
    height: 61px;
    justify-content: space-between;
    @media only screen and (max-width: 1100px) {
        display: flex;
    }
    .leftside{
        width: 61px;
        background: linear-gradient(0deg, #212541, #212541), #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        .close_menu{
            width: 20px;
            height: 20px;
            background: rgba(255, 255, 255, 0.15);
            border-radius: 6px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            svg{
                transition: .5s all;
            }
            &.roll{
                svg{
                    transform: rotate(180deg);
                }
            }
        }
    }
    .rightside{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .right{
            display: flex;
            align-items: center;
            .picture{
                position: relative;
                width: 40px;
                height: 40px;
                background: rgba(249, 60, 52, 0.12);
                border-radius: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: Montserrat;
                font-style: normal;
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
                color: #F93C34;
                cursor: pointer;
                span{
                    position: absolute;
                    top: -3px;
                    right: -3px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #FBBF24;
                    border-radius: 24px;
                    width: 18px;
                    height: 16px;
                }
            }
            .settings{
                width: 36px;
                height: 36px;
                border: 1px solid #F2F2F2;
                box-sizing: border-box;
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 10px;
                margin-left: 10px;
                &:hover{
                    background: #F2F2F2;
                }
                cursor: pointer;
            }
            .logout{
                width: 36px;
                height: 36px;
                border: 1px solid #F2F2F2;
                box-sizing: border-box;
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 10px;
                &:hover{
                    background: #F2F2F2;
                }
                cursor: pointer;
            }
        }
    }
}
</style>